export const timeRegex = new RegExp("[012][0-9]:[0-5][0-9]");
